import axios from "axios";

const API_ROOT = "https://embeds.ddhq.io/germany2021/";

const config = {
  baseURL: API_ROOT
};

const HTTP = axios.create(config);

export default {
  get: endpoint => {
    return HTTP.get(endpoint).then(response => {
      return response.data;
    });
  }
};
